import { Icon } from "@chakra-ui/react";
function InfoIcon() {
  return (
    <Icon
      width="5"
      height="5"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      color="brand.alert.infoIconColor"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 17.5V17.5C5.8575 17.5 2.5 14.1425 2.5 10V10C2.5 5.8575 5.8575 2.5 10 2.5V2.5C14.1425 2.5 17.5 5.8575 17.5 10V10C17.5 14.1425 14.1425 17.5 10 17.5Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99935 14.1667V10H9.16602"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.79084 6.66732C9.67584 6.66732 9.5825 6.76065 9.58334 6.87565C9.58334 6.99065 9.67667 7.08398 9.79167 7.08398C9.90667 7.08398 10 6.99065 10 6.87565C10 6.76065 9.90667 6.66732 9.79084 6.66732"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}

export default InfoIcon;
